import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e6ca340e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e6ca340e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ca340e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6ca340e')) {
      api.createRecord('e6ca340e', component.options)
    } else {
      api.reload('e6ca340e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e6ca340e&scoped=true", function () {
      api.rerender('e6ca340e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/ontimeDeliveryDashboard/index.vue"
export default component.exports